<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Texas Shipwrecks</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-heada">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter1#C1" title="Link target outside of Sample">Let’s Talk Shipwrecks: Five Centuries of Texas Wrecks</span></td></tr>
<tr><td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2#C2" title="Link target outside of Sample">Early Years: 1520–1775</span></td></tr>
<tr><td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3#C3" title="Link target outside of Sample">New Nations: 1776–1845</span></td></tr>
<tr><td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter4#C4" title="Link target outside of Sample">The Civil War: 1861–1865</span></td></tr>
<tr><td><span href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter5#C5" title="Link target outside of Sample">Galveston’s Golden Age: 1847–1900</span></td></tr>
<tr><td><span href="#/Chapter6#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter6#C6" title="Link target outside of Sample">Texas River Wrecks: 1830–1900</span></td></tr>
<tr><td><span href="#/Chapter7#C7" title="Link target outside of Sample">7.</span></td><td><span href="#/Chapter7#C7" title="Link target outside of Sample">Through Two World Wars: 1901–1949</span></td></tr>
<tr><td><span href="#/Chapter8#C8" title="Link target outside of Sample">8.</span></td><td><span href="#/Chapter8#C8" title="Link target outside of Sample">To the Present: 1950–2015</span></td></tr>
<tr><td><span href="#/Chapter9#C9" title="Link target outside of Sample">9.</span></td><td><span href="#/Chapter9#C9" title="Link target outside of Sample">Exploring Texas Shipwrecks: Marine Archaeology in Texas</span></td></tr>
<tr><td colspan="2"><span href="#/Museums#Mus" title="Link target outside of Sample">Museums</span></td></tr>
<tr><td colspan="2"><span href="#/Bibliography#Bib" title="Link target outside of Sample">Bibliography</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?9dc736ea